const formatDate =  (isoDate) => {
    if (!isoDate) return '';
      return isoDate.split('T')[0];
} 

const eventDateUTC = (param) => {
    
    const dateParts = param.split('-');
    const dateObject = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

    // Formater la date en français sans conversion de fuseau horaire
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = dateObject.toLocaleDateString('fr-FR', options)

    return formattedDate;
}

const getEndDateOrStart =(eventDate, endDate) => {
    if (endDate !== ""){
        return new Date(endDate)
        // new Date(endDate)
    }else{
        return new Date(eventDate)
        // new Date(eventDate)
    }

}

export const DateFormat = {
    formatDate,
    eventDateUTC,
    getEndDateOrStart
}